<template>
    <table class="table table-striped">
        <tbody class="tbodyy">
            <template v-if="myCartList.length">
                <tr
                    v-for="item in myCartList"
                    :key="`${item.product_id}-${item.storage_id}`"
                >
                    <template v-if="item.valid">
                        <td>
                            <div
                                class="cart-item-bg"
                                :style="coverImage(item)"
                            ></div>
                        </td>
                        <td>
                            <div class="cart-item-p">
                                <div>{{ item.name }} {{ item.specname }}</div>
                                <div
                                    style="
                                        font-size: 16px;
                                        font-weight: 500;
                                        letter-spacing: 0.5px;
                                    "
                                >
                                    {{ item.amount | currency }}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="cart-item-q">
                                <cart-quantity
                                    :cart-item="item"
                                ></cart-quantity>
                            </div>
                        </td>
                        <td>
                            <cart-remove-btn
                                :cart-item="item"
                            ></cart-remove-btn>
                        </td>
                    </template>
                    <template v-else>
                        <td colspan="6">商品已下架或刪除</td>
                    </template>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="6">No any item in cart.</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>
<script>
    import CartListBase from "./CartListBase.vue";

    export default {
        extends: CartListBase,
    };
</script>
<style lang="scss" scoped>
    tbody {
        > tr {
            > td {
                padding: 16px 8px;
                border-bottom: 1px solid #e8e8e8;
                border-top: none;
                transition: all 0.3s, border 0s;

                > div {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 64px;
                }
            }
        }
    }

    .cart-item-bg {
        width: 64px;
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
    }

    .cart-item-p {
        display: block;
        font-size: 14px;
        min-width: 11em;
    }

    .cart-item-q {
        min-width: 4em;
    }
</style>